import { render, staticRenderFns } from "./add-teams-modal-add-team.vue?vue&type=template&id=090ff3a1"
import script from "./add-teams-modal-add-team.vue?vue&type=script&lang=js"
export * from "./add-teams-modal-add-team.vue?vue&type=script&lang=js"
import style0 from "./add-teams-modal-add-team.vue?vue&type=style&index=0&id=090ff3a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports